/** 対象月の切り替え。月をまたぐ画面で共通して使う */

import { formatMonthLabel, shiftMonth } from '../lib/format.js';

export function MonthNav({
  month,
  onChange,
  right,
}: {
  month: string;
  onChange: (month: string) => void;
  right?: React.ReactNode;
}): React.JSX.Element {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <div className="flex items-center gap-2">
        <button
          type="button"
          className="btn btn--secondary btn--sm"
          onClick={() => onChange(shiftMonth(month, -1))}
        >
          前月
        </button>
        <span className="min-w-28 text-center font-bold">{formatMonthLabel(month)}</span>
        <button
          type="button"
          className="btn btn--secondary btn--sm"
          onClick={() => onChange(shiftMonth(month, 1))}
        >
          翌月
        </button>
      </div>
      {right}
    </div>
  );
}
